import React from "react"
import { Box } from "@chakra-ui/react"

export function BackgroundSlice({ reverse, bg }) {
  return (
    <Box
      position="relative"
      h="5.25vw"
      {...(reverse && {
        transform: "rotateZ(180deg)",
      })}
    >
      <Box as="svg" viewBox="0 0 1920 400" position="absolute" top={0} left={0}>
        <defs>
          <linearGradient
            id="highlight"
            gradientUnits="userSpaceOnUse"
            x1={0}
            y1={-100}
            x2={1920}
            y2={-100}
            gradientTransform="matrix(1 0 0 1 0 300)"
          >
            <stop offset="0.1" style={{ stopColor: "#4FC3F6" }} />
            <stop offset="0.5" style={{ stopColor: "#0288D0" }} />
          </linearGradient>
          <linearGradient
            id="highlight-glow"
            gradientUnits="userSpaceOnUse"
            x1="898.4454"
            y1="-366.622"
            x2="1041.772"
            y2="254.1935"
            gradientTransform="matrix(1 0 0 1 0 300)"
          >
            <stop
              offset={0}
              style={{ stopColor: "#4FC3F6", stopOpacity: "0.37" }}
            />
            <stop
              offset="0.35"
              style={{ stopColor: "#16243A", stopOpacity: 0 }}
            />
          </linearGradient>
        </defs>

        <path
          fill="url(#highlight)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1920,100L0,0v100H1920z"
        />
        <path
          fill={bg ? bg : "#16243A"}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0,100L1920,0v110H0V100z"
        />

        <path
          fill="url(#highlight-glow)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0,100L1920,0v400H0V100z"
        />
      </Box>
    </Box>
  )
}
